import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute } from "@tanstack/react-router";
import { BranchPage } from "@/features/chat/branch-page";

export const Route = createFileRoute("/_app/_main/code/$branchId")({ component: Page });

function Page() {
  const { branchId } = Route.useParams();
  return <BranchPage key={branchId} branchId={branchId as Id<"branches">} />;
}
